import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo.jpeg';
const _withScopeId = n => (_pushScopeId("data-v-2cd0a18b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "about-wrap"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "about-head"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "about-logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1));
const _hoisted_3 = {
  class: "about_box"
};
import nav_header from '@/components/nav_header.vue';

import { ref } from 'vue';
export default {
  __name: 'about',
  setup(__props) {
    let about = ref('');
    let public_conf = JSON.parse(localStorage.getItem('public_conf'));
    about.value = public_conf[3];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "关于我们"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_unref(about).name) + ":" + _toDisplayString(_unref(about).value), 1)])])])], 64);
    };
  }
};